import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable tag component
 */
const Tag = ({ 
  children,
  className = '',
  ...props 
}) => {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800 ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default Tag;
